import {
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_ERROR,
  ADD_USER,
  ADD_USER_SUCCESS,
  ADD_USER_ERROR,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_ERROR,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR,
  RESET_USER_FLAG,
  RESET_PASSWORD_USER,
  RESET_PASSWORD_USER_SUCCESS,
  RESET_PASSWORD_USER_ERROR,
  EDIT_PASSWORD_USER,
  EDIT_PASSWORD_USER_SUCCESS,
  EDIT_PASSWORD_USER_ERROR,
  SET_USER_PAGE,
  SET_USER_TOTAL_PAGE,
} from "./actionTypes"

export const getUsers = () => {
  return {
    type: GET_USERS,
  }
}

export const getUsersSuccess = users => {
  return {
    type: GET_USERS_SUCCESS,
    payload: { users },
  }
}

export const getUsersError = error => {
  return {
    type: GET_USERS_ERROR,
    payload: error,
  }
}

export const addUser = user => {
  return {
    type: ADD_USER,
    payload: { user },
  }
}

export const addUserSuccess = message => {
  return {
    type: ADD_USER_SUCCESS,
    payload: message,
  }
}

export const addUserError = error => {
  return {
    type: ADD_USER_ERROR,
    payload: error,
  }
}

export const editUser = user => {
  return {
    type: EDIT_USER,
    payload: { user },
  }
}

export const editUserSuccess = message => {
  return {
    type: EDIT_USER_SUCCESS,
    payload: message,
  }
}

export const editUserError = error => {
  return {
    type: EDIT_USER_ERROR,
    payload: error,
  }
}

export const editPasswordUser = user => {
  return {
    type: EDIT_PASSWORD_USER,
    payload: { user },
  }
}

export const editPasswordUserSuccess = message => {
  return {
    type: EDIT_PASSWORD_USER_SUCCESS,
    payload: message,
  }
}

export const editPasswordUserError = error => {
  return {
    type: EDIT_PASSWORD_USER_ERROR,
    payload: error,
  }
}

export const deleteUser = user => {
  return {
    type: DELETE_USER,
    payload: { user },
  }
}

export const deleteUserSuccess = message => {
  return {
    type: DELETE_USER_SUCCESS,
    payload: message,
  }
}

export const deleteUserError = error => {
  return {
    type: DELETE_USER_ERROR,
    payload: error,
  }
}

export const resetPasswordUser = user => {
  return {
    type: RESET_PASSWORD_USER,
    payload: { user },
  }
}

export const resetPasswordUserSuccess = message => {
  return {
    type: RESET_PASSWORD_USER_SUCCESS,
    payload: message,
  }
}

export const resetPasswordUserError = error => {
  return {
    type: RESET_PASSWORD_USER_ERROR,
    payload: error,
  }
}


export const setUserPage = page => {
  return {
    type: SET_USER_PAGE,
    payload: page,
  }
}


export const setUserTotalPage = totalPage => {
  return {
    type: SET_USER_TOTAL_PAGE,
    payload: totalPage,
  }
}

export const resetUserFlag = () => {
  return {
    type: RESET_USER_FLAG,
  }
}
